import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore"
import { getAuth } from "firebase/auth"
import { getStorage } from "firebase/storage"

const firebaseConfig = {
    apiKey: "AIzaSyA_DyKu2bxhkE-kCQUqN8tAH98Ls5AyWtU",
    authDomain: "bellas-mission.firebaseapp.com",
    projectId: "bellas-mission",
    storageBucket: "bellas-mission.firebasestorage.app",
    messagingSenderId: "1092088117534",
    appId: "1:1092088117534:web:9c94d4138b7e58f955f10f",
    measurementId: "G-H20DK4B6HW"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
// export const analytics = getAnalytics(app);
